import Brandlogos from '../../component/Brandlogos';
import Footer from '../../component/Footer';
import Header from '../../component/Header';
import './Intropage.css';
import Banner from './Banner';

export default function Intropage() {

  return (
    <div>
      <Header />
      <div className="section-5">
        <Banner />
      </div>
      <Footer />
    </div>
  )
}
